// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2526c3ae] .el-select-dropdown__item{padding:0;height:24px;line-height:24px}", ""]);
// Exports
module.exports = exports;
